var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProgress0 = function SvgProgress0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M37.058 54.622c.276.977 1.294 1.55 2.248 1.209a26.698 26.698 0 1 0-18.886-.333c.942.376 1.98-.162 2.29-1.128.31-.966-.226-1.993-1.164-2.379a23.024 23.024 0 1 1 16.759.295c-.951.352-1.523 1.36-1.247 2.336Z"
  })));
};
export default SvgProgress0;